import { useEffect, useState } from "react";
import appApi from "../../assets/utils/AppApi";

export default function useReportCardRequest(path, page, filter) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError("");
    setData(null);
    appApi.get(path, { params: { page, limit: 10, ...(filter ? { filter } : {}) }, signal: controller.signal })
      .then(response => {
        if (!controller.signal.aborted) setData(response.data);
      })
      .catch(err => {
        if (!controller.signal.aborted) {
          setError(err.response?.data?.msgFa || "دریافت کارنامه‌ها ممکن نشد. لطفاً دوباره تلاش کنید.");
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, [path, page, filter, refresh]);

  return { data, loading, error, retry: () => setRefresh(value => value + 1) };
}
